import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchAssinaturaStatus } from "../api/assinaturaApi";
import { sessionManager } from "../utils/sessionManager";

const ROTAS_LIBERADAS = ["/assinatura", "/perfil", "/login", "/primeiro-acesso"];

const rotaPermitidaSemPlano = (pathname) =>
  ROTAS_LIBERADAS.some((rota) => pathname.startsWith(rota));

const AssinaturaGuard = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const usuario = sessionManager.obterUsuario();
  const tipo = String(usuario?.tipo || "").toLowerCase();
  const [estado, setEstado] = useState({ loading: true, bloqueado: false, somenteLeitura: false });

  const verificar = useCallback(async () => {
    if (tipo === "super_admin") {
      setEstado({ loading: false, bloqueado: false, somenteLeitura: false });
      return;
    }

    try {
      const data = await fetchAssinaturaStatus();
      const liberado = Boolean(data?.acesso?.liberado);
      const somenteLeitura = Boolean(data?.acesso?.somenteLeitura);
      const bloqueado = !liberado;
      setEstado({ loading: false, bloqueado, somenteLeitura });

      if (bloqueado && !rotaPermitidaSemPlano(location.pathname)) {
        navigate("/assinatura", { replace: true });
      }
    } catch {
      setEstado({ loading: false, bloqueado: true, somenteLeitura: false });
      if (!rotaPermitidaSemPlano(location.pathname)) {
        navigate("/assinatura", { replace: true });
      }
    }
  }, [location.pathname, navigate, tipo]);

  useEffect(() => {
    verificar();
    const handler = () => verificar();
    window.addEventListener("fz:assinatura:changed", handler);
    return () => window.removeEventListener("fz:assinatura:changed", handler);
  }, [verificar]);

  useEffect(() => {
    if (estado.somenteLeitura) {
      document.body.classList.add("fz-modo-leitura-assinatura");
    } else {
      document.body.classList.remove("fz-modo-leitura-assinatura");
    }
    return () => {
      document.body.classList.remove("fz-modo-leitura-assinatura");
    };
  }, [estado.somenteLeitura]);

  if (estado.loading) {
    return <p className="muted">Verificando assinatura...</p>;
  }

  if (estado.bloqueado && !rotaPermitidaSemPlano(location.pathname)) {
    return null;
  }

  return children;
};

export default AssinaturaGuard;
